import { render } from "./template.vue?vue&type=template&id=4377470d&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=4377470d&lang=scss"
import "./template.vue?vue&type=style&index=1&id=4377470d&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4377470d"]])

export default __exports__